import { useAppDispatch } from '../../app/hooks';
import { TableActionsBar } from 'shared-components';
import { useDeleteArchiveMutation, useGetArchivesQuery } from './archives.api';
import { open } from '../modal/modalSlice';
import { Button } from 'shared-components';
import { toast } from 'react-toastify';
import { ButtonIntent } from 'shared-components';

export const Archives = ({ eventId }: { eventId: string }) => {
  const { data, isLoading } = useGetArchivesQuery();
  const [deleteArchive] = useDeleteArchiveMutation();
  const dispatch = useAppDispatch();
  if (isLoading) {
    return <span>loading...</span>;
  }
  return (
    <>
      <TableActionsBar
        singularActions={[
          {
            action: () => {
              dispatch(
                open({
                  title: 'Upload archive',
                  contentKey: 'archive-upload',
                })
              );
            },
            display: 'Upload archive',
            value: 'upload-archive',
          },
        ]}
      />

      <table>
        <thead>
          <tr>
            <th>Archive</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((t) => (
            <tr
              onClick={() => {
                dispatch(
                  open({
                    title: 'Unpack archive',
                    contentKey: 'unpack-archive',
                    contentPayload: {
                      filename: t,
                      eventId,
                    },
                  })
                );
              }}
              key={t}
            >
              <td>{t}</td>
              <td>
                <Button
                  intent={ButtonIntent.Negative}
                  onClick={async (evt) => {
                    evt.preventDefault();
                    evt.stopPropagation();

                    if (
                      // eslint-disable-next-line no-restricted-globals
                      confirm('Are you sure you want to delete this archive?')
                    ) {
                      await deleteArchive(t);
                      toast.success('Archive deleted');
                    }
                  }}
                >
                  Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};
